import React, { createContext, useReducer, Dispatch, useContext } from "react"

type State = {
  scenario: string
  page: number
}

type Action =
  | { type: "SELECT_SCENARIO"; scenario: string }
  | { type: "MOVE_NEXT" }
  | { type: "MOVE_PREV" }
  | { type: "MOVE_TO"; page: number }
  | null

type dispatchType = Dispatch<Action>

const initialState = {
  scenario: "",
  page: 0,
}

export const stateContext = createContext<State | null>(null)
export const dispatchContext = createContext<dispatchType | null>(null)

function reducer(state: State, action: Action) {
  switch (action?.type) {
    case "SELECT_SCENARIO":
      return {
        scenario: action.scenario,
        page: state.page + 1,
      }
    case "MOVE_NEXT":
      return {
        ...state,
        page: state.page + 1,
      }
    case "MOVE_PREV":
      return {
        ...state,
        page: state.page - 1,
      }
    case "MOVE_TO":
      return {
        ...state,
        page: action.page,
      }
    default:
      return state
  }
}

export const StateProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <stateContext.Provider value={state}>
      <dispatchContext.Provider value={dispatch}>{children}</dispatchContext.Provider>
    </stateContext.Provider>
  )
}

export const useStateContext = () => useContext(stateContext)
export const useDispatchContext = () => useContext(dispatchContext)
